import logo from 'assets/images/netgear-insight.png';
import { useNavigate } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { useOrganization } from '../contexts/OrganizationContext';
// ==============================|| HEADER WORDMARK ||============================== //

export default function Logo() {
  const navigate = useNavigate();
  const intl = useIntl();
  const { updateOrganizationContext } = useOrganization();
  const navigateToMSPHome = () => {
    // Navigate to MSP Home / All Organizations
    localStorage.setItem("scopeId", 0);
    // Label must come from intl — a hardcoded string leaks English into the hierarchy tree and
    // breadcrumbs after the user switches language.
    updateOrganizationContext(null, '0', null, {
      id: "All Organizations",
      label: intl.formatMessage({ id: 'allOrganizations' }),
      type: "All Organizations",
      icon: "All Organizations"
    });
    navigate('/mspHome/dashboard');  // navigating to the msp home when the All Organizations is clicked
  }

  return (
    <img src={logo} onClick={() => {navigateToMSPHome()}} alt="Netgear" style={{cursor:"pointer"}} width="124" height="30" />
  );
}
